import React from "react";
import Layout from "../layout/layout";
import { Form } from "react-bootstrap";
import searchicon from "../../assets/images/header/search.svg";
import "./search.css";
import SearchBody from "./searchbody";
import searchred from "../../assets/images/header/search-red.svg";
// import { Helmet } from "react-helmet";

const SearchPage = () => {
  return (
    <>
   {/* <Helmet>
     <html className="search-page" lang="en" />
   </Helmet> */}
    <Layout>
      <div className="search-page">
        <div className="container">
          <div className="search-heading">
            <Form>
              <Form.Group className="input-img">
                <img src={searchicon} alt="" />
                <Form.Control type="text" placeholder="deadwood" />
              </Form.Group>
            </Form>
          </div>
          <SearchBody title="All Result" titleImg={searchred} />
          {/* <div className='search-body'>
            <div className='result-sec'>
              <div className='all-result'>
                <h6>
                  <img src={searchred} alt='' /> All Results
                </h6>
              </div>
              <div className='sort-sec'>
                <Button>Providers</Button>
                <Button>Popular</Button>
              </div>
            </div>

            <div className='all-result-sec'>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
              <div className='result-box'>
                <div className='result-sub-box'>
                  <img src={deadwood} alt='' />
                </div>
                <div className='info-box'>
                  <div className='info-heading'>
                    <h6>Deadwood</h6>
                    <p>No Limit City</p>
                  </div>
                  <div className='info-icon'>
                    <img src={info} alt='' />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </Layout>
    </>
  );
};

export default SearchPage;
